<template>
  <form
    v-if="t"
    @submit.prevent.stop="">
    <div class="is-padding">
      <div class="columns is-multiline">
        <div class="column is-6">
          <v-input
            id="name"
            name="name"
            @input="t.name = $event"
            :model="t.name"
            v-validate="'required'"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as="raison sociale">
            <r-label
              slot="label"
              :is-required="true"
              :label="'Raison sociale'"
              :value="t.name"></r-label>
          </v-input>
        </div>
        <div class="column is-6">
          <r-label
            :is-required="true"
            :label="'Type de tiers'"
            :value="t.type"></r-label>
          <div class="control">
            <multiselect
              v-model="selectedType"
              :placeholder="''"
              id="type"
              label="label"
              track-by="value"
              :options="tiersTypes"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              class="multiselect--option-ico">
              <span slot="noResult">Oups! Aucun type trouvé.</span>
              <span slot="noOptions">La liste est vide</span>
              <span
                slot="placeholder"
                class="multiselect__placeholder">Sélectionnez un type</span>
            </multiselect>
          </div>
        </div>
        <div class="column is-6">
          <v-input
            id="phone"
            name="phone"
            @input="t.phone = $event"
            :model="t.phone"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as="téléphone"
            :has-addons="true">
            <r-label
              slot="label"
              :is-required="false"
              :label="'Téléphone'"
              :value="t.phone"></r-label>
            <p
              class="control"
              slot="addonLeft">
              <a class="button is-square is-static is-border">
                <span class="icon"><i class="fas fa-phone-office"></i></span>
              </a>
            </p>
          </v-input>
        </div>
        <div class="column is-6">
          <v-input
            id="email"
            name="email"
            @input="t.email = $event"
            :model="t.email"
            v-validate="'email'"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as="email"
            :has-addons="true">
            <r-label
              slot="label"
              :is-required="false"
              :label="'Email'"
              :value="t.email"></r-label>
            <p
              class="control"
              slot="addonLeft">
              <a class="button is-square is-static is-border">
                <span class="icon"><i class="fas fa-paper-plane"></i></span>
              </a>
            </p>
          </v-input>
        </div>
        <div class="column is-6">
          <v-input
            id="website"
            name="website"
            @input="t.website = $event"
            :model="t.website"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as="site web"
            :has-addons="true">
            <r-label
              slot="label"
              :is-required="false"
              :label="'Site web'"
              :value="t.website"></r-label>
            <p
              class="control"
              slot="addonLeft">
              <a class="button is-square is-static is-border">
                <span class="icon"><i class="fal fa-link"></i></span>
              </a>
            </p>
          </v-input>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label is-uppercase is-size-7">Favori</label>
            <div class="control is-margin-top">
              <input
                id="favorite"
                name="favorite"
                class="switch is-success is-rounded is-medium"
                type="checkbox"
                :checked="!!t.favorite"
                @change="t.favorite = $event.target.checked">
              <label
                v-if="!t.favorite"
                for="favorite">Non</label>
              <label
                v-else
                for="favorite">Oui</label>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <address-input
            :source="t.address"
            :model="t.address"
            :has-addons="true"
            @update="updateAddress">
          </address-input>
        </div>
      </div>
    </div>
    <div class="is-padding has-background-light">
      <div class="columns is-gapless is-marginless-bottom">
        <div class="column is-self-centered">
          <span class="is-uppercase title is-6">Interlocuteurs</span>
        </div>
      </div>
      <div
        v-for="(interlocuteur, idx) in t.interlocuteurs"
        :key="'interlocuteur-' + idx"
        class="is-flex has-background-white is-border is-margin-top-xsmall">
        <div class="column columns is-vcentered is-marginless">
          <div class="column is-narrow">
            <avatar
              :item="interlocuteur"
              :i="idx" />
          </div>
          <div class="column">
            <div class="is-size-5 has-text-weight-medium">
              <span class="is-uppercase">{{ interlocuteur.last_name }}</span> {{ interlocuteur.first_name }}
              <span
                v-if="interlocuteur.role"
                class="has-text-grey"> — {{ interlocuteur.role }}</span>
            </div>
            <div class="is-size-6 has-text-grey">
              <span v-if="interlocuteur.phone">
                <span class="icon is-small is-margin-right-xxsmall"><i class="fal fa-phone-office"></i></span>
                <phone-number :phone="interlocuteur.phone"></phone-number>
              </span>
              <span
                v-if="interlocuteur.email"
                :class="{'is-margin-left-xsmall': interlocuteur.phone}">
                <span class="icon is-small"><i class="fal fa-paper-plane"></i></span>
                {{ interlocuteur.email }}
              </span>
            </div>
          </div>
        </div>
        <div class="actionsOnRow actionsOnRow--vertical">
          <div>
            <button
              type="button"
              class="tooltip is-tooltip-left is-min-height-full"
              data-tooltip="Modifier l'interlocuteur"
              @click="openInterlocuteurPanel(idx)">
              <span class="icon"><i class="fal fa-user-edit"></i></span>
            </button>
          </div>
          <div>
            <button
              type="button"
              class="tooltip is-tooltip-left actionsOnRow-btn--hoverIsDanger is-min-height-full"
              data-tooltip="Supprimer l'interlocuteur"
              @click="removeInterlocuteur(idx)">
              <span class="icon"><i class="fal fa-trash-alt"></i></span>
            </button>
          </div>
        </div>
      </div>
      <div class="row-width-actions-bar is-margin-top-xsmall">
        <button
          type="button"
          class="page-header-btn button is-dark is-fullwidth is-radiusless"
          @click="openInterlocuteurPanel(null)">
          <span>Ajouter un interlocuteur</span>
        </button>
      </div>
    </div>
    <div class="is-padding">
      <div class="field">
        <label class="label is-uppercase is-size-7">Commentaire</label>
        <div class="control">
          <wysiwyg-editor
            :light="true"
            :tooltip-top="true"
            :model="t.comment"
            @change="val => t.comment = val"
            class="editr--bottom-toolbar no-toolbar editr--height-small content">
          </wysiwyg-editor>
        </div>
      </div>
    </div>
    <submit-sticky-buttons
      @submit="submit"
      :loading="submitLoading || sourceLoading"
      button-id="tiersForm"></submit-sticky-buttons>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import TiersMixin from './TiersMixin'

export default {
  name: 'TiersForm',
  mixins: [TiersMixin],
  data () {
    return {
      editedInterlocuteurIdx: null,
      panelOpenedFromQuery: false
    }
  },
  computed: {
    ...mapState(['quickview']),
    selectedType: {
      get () {
        return this.tiersTypes.find(type => type.value === this.t.type) || null
      },
      set (type) {
        this.t.type = type ? type.value : null
      }
    }
  },
  watch: {
    t: {
      immediate: true,
      handler (t) {
        if (t && !t.interlocuteurs) {
          this.$set(t, 'interlocuteurs', [])
        }
        // arrivée depuis la liste des interlocuteurs : ouvre le slide panel de la personne ciblée
        if (t && t.pk && !this.panelOpenedFromQuery && this.$route.query.interlocuteur) {
          const idx = (t.interlocuteurs || []).findIndex(i => i.pk === this.$route.query.interlocuteur)
          if (idx >= 0) {
            this.panelOpenedFromQuery = true
            this.openInterlocuteurPanel(idx)
          }
        }
      }
    },
    quickview ({ mode, params, results }) {
      if (results && mode === 'INTERLOCUTEUR_FORM') {
        if (this.editedInterlocuteurIdx !== null) {
          this.t.interlocuteurs.splice(this.editedInterlocuteurIdx, 1, results.interlocuteur)
        } else {
          this.t.interlocuteurs.push(results.interlocuteur)
        }
        this.editedInterlocuteurIdx = null
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
      }
    }
  },
  methods: {
    /**
     * Ouvre le slide panel de création (idx null) ou d'édition d'un interlocuteur
     * @param {number} idx
     */
    openInterlocuteurPanel (idx = null) {
      this.editedInterlocuteurIdx = idx
      this.$store.commit('setQuickview', {
        mode: 'INTERLOCUTEUR_FORM',
        params: {
          source: idx !== null ? { ...this.t.interlocuteurs[idx] } : {}
        }
      })
    },
    async removeInterlocuteur (idx) {
      const interlocuteur = this.t.interlocuteurs[idx]
      let value = await this.$swal({
        title: 'Suppression interlocuteur',
        text: `Êtes vous sûr de vouloir supprimer ${interlocuteur.last_name || ''} ${interlocuteur.first_name || ''} ? La suppression sera effective à l'enregistrement de la fiche.`,
        confirmButtonText: 'Supprimer',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false
      this.t.interlocuteurs.splice(idx, 1)
    },
    updateAddress (address) {
      this.$set(this.t, 'address', address)
    },
    async submit () {
      const formIsValid = await this.$validator.validateAll()
      if (!formIsValid) {
        this.$toasted.global.danger('Veuillez vérifier les champs du formulaire')
        return
      }
      if (!this.t.type) {
        this.$toasted.global.danger('Veuillez sélectionner un type de tiers')
        return
      }
      const tiers = { ...this.t }
      if (!tiers.interlocuteurs.some(i => i.last_name)) {
        this.$toasted.global.danger('Veuillez renseigner au moins un interlocuteur')
        return
      }
      this.$emit('submit', tiers)
    }
  }
}
</script>
